<vzc-side-drawer
  insightsPanelDrawer
  #ipDrawer="insightsPanelDrawer"
  [mode]="ipDrawer.drawerMode$ | async"
  [userPreferences]="userPreferences$ | async"
  [ngClass]="{ 'fullscreen-mode': isFullscreen$ | async }"
>
  <ng-content></ng-content>
</vzc-side-drawer>
